import { render, staticRenderFns } from "./ScrollingIndicator.vue?vue&type=template&id=3414d07e&scoped=true&"
import script from "./ScrollingIndicator.vue?vue&type=script&lang=js&"
export * from "./ScrollingIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ScrollingIndicator.vue?vue&type=style&index=0&id=3414d07e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3414d07e",
  null
  
)

export default component.exports